var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require( 'react' );
var PropTypes = require('prop-types');
var createReactClass = require('create-react-class');
var SubNavListItem = require('./subNavListItem.jsx');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var SubNav = createReactClass({
	mixins: [PureRenderMixin],

	getName: function(item) {
		return (item.topic === "what_is") ? item.title : item.topic.replace(/_/g, ' ');
	},

    componentDidMount: function(){
		new Foundation.Sticky($('#sticky'), {
			topAnchor: 'sub-nav-wrapper',
			marginTop: 3.75
		});
		$(window).trigger('load.zf.sticky');

        new Foundation.Magellan($('#subNav'), {
            activeClass: 'active',
			threshold: 140,
			barOffset: 70
        });

        var $subNav = $('#subNav');
        $subNav.foundation('reflow'); // for calcPoints and _updateActive
        $('.content img').on('load', function(){
            $subNav.foundation('reflow');
        });

        Foundation.IHearYou(); // for triggering foundation event
    },

	componentWillUnmount: function(){
		$('#sticky').foundation('destroy');
	},

    reInitializeMagellan: function(){
        $('[data-magellan-target]').each(function(i, ele){
            var $ele = $(ele);
            $ele.data('magellan-target', $ele.attr('data-magellan-target'))
        });
        $('#subNav').foundation('_init');
        $('#subNav').foundation('reflow');
    },

	render: function(){
	    var subMenu = this.props.education.map(function (item, i) {
	  	  return (
	          <SubNavListItem
	            key={i}
	            arrival={item.topic}
	  		    name={this.props.getName ? this.props.getName(item) : this.getName(item)}
	            title={item.title} />
	        );
	    }.bind(this));

		return (
			<div className="row expanded hide-for-small-only" data-sticky-container>
				<div className="column" id="sticky">
					<nav className="sub-nav" id="subNav">
						<ul className="no-bullet">
							{subMenu}
						</ul>
					</nav>
				</div>
			</div>
		)
	}
});

SubNav.propTypes = {
	title: PropTypes.string,
	name: PropTypes.string
};

module.exports = SubNav;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/subNav.jsx